module.exports = __webpack_public_path__ + "img/image-lower-banner.052856c3.png";